import en from 'applications/GSP/app/providers/TranslationProvider/lang/en.json';
import { FALLBACK_LNG, NS } from 'shared/constants/translation';

export const getTestResources = () => ({
  [FALLBACK_LNG]: { [NS]: en },
});
